import { render, staticRenderFns } from "./extra-style-upload-image.vue?vue&type=template&id=0bf78bf9&scoped=true&"
import script from "./extra-style-upload-image.vue?vue&type=script&lang=js&"
export * from "./extra-style-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./extra-style-upload-image.vue?vue&type=style&index=0&id=0bf78bf9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf78bf9",
  null
  
)

export default component.exports